import Immutable from 'immutable';

export const initialState = Immutable.Map({
  my_bundles: Immutable.List(),
  other_bundles: Immutable.List(),
});
